import React, { useEffect } from "react";
import { FormGroup, FormText, Label } from "reactstrap";
import ElementSpacer from "../../../Layout/Components/ElementSpacer";
import { FeedbackTagPicker } from "../../../Tags";

type Props = {
  selectedTagIds: number[];
  onChangeTags: (tagIds: number[]) => void;
};

const FeedbackFormTagsInput: React.FC<Props> = props => {
  return (
    <FormGroup>
      <Label for="tags">
        <ElementSpacer spacing=".25rem">Tag</ElementSpacer>
      </Label>
      <FeedbackTagPicker
        selectedIds={props.selectedTagIds}
        onSelectedTagsChange={props.onChangeTags}
      />
      <FormText>
        A Tag applied to a Feedback can act a category, or it can allow the Feedback to be searched
        more easily later
      </FormText>
    </FormGroup>
  );
};

export default FeedbackFormTagsInput;
